export default "__VITE_ASSET__vWOyED3E__"